import { ICDAuxCheckboxModel } from "./icd-aux-checkbox.model";
import { ICDBaseModel } from "./icd-base.model";

export class ICDClockModel extends ICDBaseModel {
  public auxModel: ICDAuxCheckboxModel = null;
  private _value: string;

  constructor(value?: string) {
    super();
    this._value = value != null ? value : null;
  }

  public get value(): string {
    return this._value;
  }
  public set value(value: string) {
    this._value = value;
  }
}
